import SvgComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption
 * @typedef {("right" | "left")} IconAlignment
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String?} props.disabledTextColor - Color of text when button is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {String} props.icon - Takes svg as an props
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {boolean} props.inActiveVariantNeeded - If you want to use inActive variant of button eg:- true or false
 * @param {String} props.imgColor - Takes svg color as an props
 * @returns {JSX.Element}
 */
const PrimaryRightIconFill = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  icon,
  hoverOption,
  buttonRef,
  inActiveVariantNeeded,
  imgColor,
  isNeedOutLine,
  isOytLineColor,
}) => {
  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative ${isNeedOutLine && `border-border border-${isOytLineColor}`} justify-center items-center py-padding-sm px-padding-md w-full h-auto rounded-border-radius-md cursor-${
        isDisabled
          ? `not-allowed ${inActiveVariantNeeded ? "" : "opacity-light-opacity"} `
          : `pointer ${
              hoverOption === "white"
                ? "global-hover-white"
                : "global-hover-black"
            }`
      }`}
      style={{
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor.toString()
            : enabledBgColor.toString(),
      }}
    >
      <div
        className={`flex flex-row items-center gap-gap-button-s justify-between w-full`}
      >
        <div
          className={`flex justify-center items-center text-font-xs font-normal wrap-break-word`}
          style={{
            color:
              isDisabled && disabledTextColor
                ? disabledTextColor
                : enabledTextColor,
          }}
        >
          {btnText}
        </div>
        <SvgComponent
          color={imgColor}
          height="var(--icon-sm)"
          width="var(--icon-sm)"
          url={icon}
          alt="CustomIcon"
        />
      </div>
    </button>
  );
};

export default PrimaryRightIconFill;
